import { FC, MutableRefObject, useRef } from 'react'
import { Box } from '@mui/material'
import { Tooltip } from '../../graphql/__generated__/graphql.autogenerated'
import { BreakdownTooltip } from '../../model/Breakdown'
import ScrollToTargetButton from '../scroll/ScrollToTargetButton'
import ClickableModalTooltip from './clickableModalTooltip/ClickableModalTooltip'
import CustomTooltipContent from './customTooltipContent/CustomTooltipContent'

type TooltipContainerProps = {
  tooltip: Tooltip | BreakdownTooltip[]
  targetRef?: MutableRefObject<undefined>
  className?: string
  index?: number
}

const TooltipContainer: FC<TooltipContainerProps> = ({
  tooltip,
  className = '',
  index,
  targetRef,
}) => {
  const localRef = useRef()

  const renderCustomTooltip = () => {
    if ('tooltipPlaceholders' in tooltip) {
      const formattedPlaceholders = tooltip?.tooltipPlaceholders.reduce(
        (acc, { key, value }) => ({ ...acc, [key]: value }),
        {}
      )
      return (
        <ClickableModalTooltip className={className} isHeader={true}>
          <CustomTooltipContent
            description={tooltip?.text}
            translationPlaceholders={formattedPlaceholders}
          />
        </ClickableModalTooltip>
      )
    }

    return (
      <Box
        display="inline-flex"
        alignItems="center"
        data-test={`summary:finance-breakdown-element_tooltip${index}`}
      >
        {tooltip.map((tooltip, tooltipIndex) => {
          if (
            Object.prototype.hasOwnProperty.call(tooltip, 'number') &&
            tooltip.number
          ) {
            return (
              <Box ref={localRef}>
                <ScrollToTargetButton
                  key={tooltip.number}
                  value={tooltip.number}
                  targetRef={targetRef || localRef}
                />
              </Box>
            )
          }

          return (
            <ClickableModalTooltip
              key={tooltipIndex}
              className={className}
              isHeader={true}
            >
              <CustomTooltipContent
                description={tooltip.description}
                translationPlaceholders={tooltip.translationPlaceholders}
              />
            </ClickableModalTooltip>
          )
        })}
      </Box>
    )
  }

  return renderCustomTooltip()
}

export default TooltipContainer
